export const images = {
  logo: '/assets/logo.svg',
  avatar: '/assets/image-avatar.jpg',
  sun: '/assets/icon-sun.svg',
  moon: '/assets/icon-moon.svg',
  plus: '/assets/icon-plus.svg',
  up: '/assets/icon-arrow-up.png',
  down: '/assets/icon-arrow-down.svg',
  left: '/assets/icon-arrow-left.svg',
  right: '/assets/icon-arrow-right.svg',
  delete: '/assets/icon-delete.svg',
  deleteHover: '/assets/icon-delete-hover.png',
  calender: '/assets/icon-calender.svg',
  illustration: '/assets/illustration-empty.svg',
};
